export default __webpack_public_path__ + "static/media/about_rectangle_1.4a808659.svg";